export default "__VITE_ASSET__B7PX4Bc8__"